<template>
  <div id="app">
    <ExcelSheet fileName="LockerExcel" :importData="importData">

      <template v-slot:top>

        <div
        style="width:300px ;float:left; ">
        <universal-input 
        label="fromDate"
        v-model="centerFilter"
        :config="centerFilterConfig"
      >
      </universal-input>
    </div>

        <div style="width:300px ;float: left; padding-left:12px">
          <universal-input v-model="courseFromDate" :config="courseFromDateConfig"> 
        
          </universal-input>
        </div>

        <div style="width:300px ;float: left; padding-left:12px">
          <universal-input v-model="courseToDate" :config="courseToDateConfig"
       >
          </universal-input>
        </div>
      </template>

    </ExcelSheet>

  </div>
</template>

<script setup>

import ExcelSheet from '@/components/Excel/excelSheet.vue'

import { showExcel } from '@/api/locker'

import { ownCenterList } from '@/api/center'



import moment from '@/utils/moment'
import UniversalInput from '@/components/CRUD/UniversalInput'

import { ref, onMounted, computed, toRefs, watch, onBeforeMount } from 'vue'

let AllCenter = ''
let AllCenterArray = [{id : 0 , label : 'ALL'}]
const headerJSON = ref( [])
const coachCenterList = ref([{
          id: 0,
          label: 'ALL',
        }])

const TempData = ref([])
const importData = ref({})
const merge = ref([])

const centerFilter = ref(0)
const centerFilterConfig = ref({
  name: 'centerFilter',
  label: 'Center',
  type: {
    name: 'autocomplete',
    items: coachCenterList.value,
  },
})
 

 
const courseFromDate = ref('')
const courseToDate = ref('')
const border_1 = ref([])
const startingRowNumber = ref(5)
 

const courseFromDateConfig = ref({
  propName: 'courseFromDate',
  label: 'From Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})

const courseToDateConfig = ref({
  propName: 'courseToDate',
  label: 'To Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})
 


watch(centerFilter,  newValue => {
  console.log('centerFilter',centerFilter)
  if (newValue) {
    console.log('watchcenterFilter' , newValue)
   headerJSON.value =  [
  { Info: 'Center Locker Status and Activity Report', fs: 18 },
  { Info: 'Center : ' + AllCenterArray[AllCenterArray.findIndex(item=> item.id === centerFilter.value)].label , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value  +'~' +courseToDate.value  , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm'), fs: 14 },
  { Info: '' }, // Empty row
  { Info: '', bg: '#808080' }, // for header row 5
]

    callAPI({CenterID : newValue, ToDate: courseToDate.value , FromDate : courseFromDate.value})
  }else{
    
    console.log('watchcenterFilter' , newValue)
   headerJSON.value =  [
  { Info: 'Center Locker Status and Activity Report', fs: 18 },
  { Info: `Center : ${AllCenterArray[0].label}` , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value  +'~' +courseToDate.value  , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm'), fs: 14 },
  { Info: '' }, // Empty row
  { Info: '', bg: '#808080' }, // for header row 5
]

    callAPI({CenterID : newValue, ToDate: courseToDate.value , FromDate : courseFromDate.value})
  }


  
}
 
)

watch(courseFromDate,  newValue => {
  if (newValue){
    callAPI({CenterID : centerFilter.value , ToDate: courseToDate.value , FromDate : newValue})
   
   headerJSON.value = [
  { Info: 'Center Locker Status and Activity Report', fs: 18 },
  { Info: 'Center : '  + AllCenterArray[AllCenterArray.findIndex(item=> item.id === centerFilter.value)].label, fs: 18 },
  { Info: 'Date : ' + newValue  +'~' +courseToDate.value  , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm'), fs: 14 },
  { Info: '' }, // Empty row
  { Info: '', bg: '#808080' }, // for header row 5
  // #D9D9D9  other gray
] 
}
})

watch(courseToDate,  newValue => {
  if (newValue){
    callAPI({CenterID : centerFilter.value , ToDate: newValue , FromDate : courseFromDate.value})
    
   headerJSON.value = [
  { Info: 'Center Locker Status and Activity Report', fs: 18 },
  { Info: 'Center : ' +  AllCenterArray[AllCenterArray.findIndex(item=> item.id === centerFilter.value)].label , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value  +'~' +  newValue , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm'), fs: 14 },
  { Info: '' }, // Empty row
  { Info: '', bg: '#808080' }, // for header row 5
  // #D9D9D9  other gray
] 
}
})

onBeforeMount(() => {




  
})


onMounted(() => {

 

  courseFromDate.value =   moment().subtract(7, 'days').format('YYYY-MM-DD')
courseToDate.value =  moment().format('YYYY-MM-DD') 
 
ownCenterList().then(response => {
    console.log('response', response)
 
    for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
 
        coachCenterList.value.push({
          id: item.id,
          label: item.code,
        })
      
      }
    }
    // console.log('coachCenterList.value', coachCenterList.value)

    if  ( coachCenterList.value.length > 2 ){
      AllCenter = 'ALL('
      console.log('coachCenterList.value[0].label1',coachCenterList.value[0].label)
 
      for (let index = 1; index < coachCenterList.value.length; index += 1) 
      {
        AllCenter +=  coachCenterList.value[index].label + ', ' 
        AllCenterArray.push({
          id: index,
          label: coachCenterList.value[index].label,
        })
      }
    
      AllCenter = AllCenter.slice(0, -2);
      AllCenter += ')'
      AllCenterArray[0].label = AllCenter
     
    }
console.log('AllCenterArray',AllCenterArray)

setTimeout(function() {
   
 
    centerFilter.value = false
}, 1500);

    // callAPI({ CenterID: centerFilter.value,  ToDate: courseToDate.value , FromDate : courseFromDate.value})

    // showExcel({ CenterID: centerFilter.value,  ToDate: courseToDate.value , FromDate : courseFromDate.value})
    //   .then(lockerExcelresponse => {
    //     console.log('lockerExcelresponse', lockerExcelresponse)
    //     let newArray = lockerExcelresponse.data.record;
    //     // console.log('newArray',newArray)
    //     newArray = addBgToPreSecondLockerID(newArray)
    //     // console.log('addBgToPreSecondLockerID',newArray)
    //     newArray = convertTransactionDates(newArray)

    //     merge.value = generateMergeJson(newArray, 6, 0)

    //     TempData.value = [...headerJSON.value, ...newArray];
    //     //  console.log('importData',importData.value)

    //     const temp = initLuckysheet(TempData.value)
    //     console.log('temp', temp)
    //     importData.value = temp




    //   })
    //   .catch(err => {
    //     console.log('err', err)
    //   })
  })
    .catch(err => {
      console.log('err', err)
    })



})

function addBgToPreSecondLockerID(lockers) {
  let addColor = false // if true add color
  let tempID = 0
  try {
    tempID = lockers[0].lockerID;
  } catch
  {

  }

  for (let i = 0; i < lockers.length; i++) {


    if (i == 0) {

    }
    else {
      if (lockers[i].lockerID != tempID) {
        addColor = !addColor
        tempID = lockers[i].lockerID
      }


      if (addColor)
        lockers[i].bg = '#D9D9D9';

    }


  }

  return lockers;
}

// function generateMergeJson(data, rowOffset, columnOffset) {
//   const mergeJson = {};
//   const mergeStart = {};
//   // const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus"];
//   const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus"];
//   data.forEach((row, i) => {
//     let allKeysMatch = true;
//     keysToMerge.forEach((key) => {
//       if (i === 0 || row[key] !== data[i - 1][key]) {
//         allKeysMatch = false;
//       }
//     });

//     if (allKeysMatch) {
//       keysToMerge.forEach((key) => {
//         mergeStart[key] = (mergeStart[key] || 0) + 1;
//       });
//     } else {
//       keysToMerge.forEach((key, j) => {
//         if (mergeStart[key] && mergeStart[key] > 1) {
//           const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`;
//           mergeJson[mergeKey] = {
//             rs: mergeStart[key],
//             cs: 1,
//             r: i - mergeStart[key] + rowOffset,
//             c: j + columnOffset,
//           };
//         }
//         mergeStart[key] = 1;
//       });
//     }
//   });


//   keysToMerge.forEach((key, j) => {
//     if (mergeStart[key] && mergeStart[key] > 1) {
//       const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`;
//       mergeJson[mergeKey] = {
//         rs: mergeStart[key],
//         cs: 1,
//         r: data.length - mergeStart[key] + rowOffset,
//         c: j + columnOffset,
//       };
//     }
//   });

//   // If the LockerNo column is not merged, other columns should not be merged as well
//   if (!mergeJson[`${rowOffset}_0`]) {
//     Object.keys(mergeJson).forEach((key) => {
//       if (key.endsWith(`_${columnOffset + 1}`) || key.endsWith(`_${columnOffset + 2}`)) {
//         delete mergeJson[key];
//       }
//     });
//   }

//   return  mergeJson  ;
// }
function generateMergeJson(data, rowOffset, columnOffset) {
  const mergeJson = {};
  const mergeStart = {};
  const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus", "currentUser"];

  data.forEach((row, i) => {
    let lockerIdMatch = true;
    if (i === 0 || row["lockerID"] !== data[i - 1]["lockerID"]) {
      lockerIdMatch = false;
    }

    if (lockerIdMatch) {
      keysToMerge.forEach((key) => {
        mergeStart[key] = (mergeStart[key] || 0) + 1;
      });
    } else {
      keysToMerge.forEach((key, j) => {
        if (mergeStart[key] && mergeStart[key] > 1) {
          const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`;
          mergeJson[mergeKey] = {
            rs: mergeStart[key],
            cs: 1,
            r: i - mergeStart[key] + rowOffset,
            c: j + columnOffset,
          };
        }
        mergeStart[key] = 1;
      });
    }
  });

  keysToMerge.forEach((key, j) => {
    if (mergeStart[key] && mergeStart[key] > 1) {
      const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`;
      mergeJson[mergeKey] = {
        rs: mergeStart[key],
        cs: 1,
        r: data.length - mergeStart[key] + rowOffset,
        c: j + columnOffset,
      };
    }
  });

  return mergeJson;
}



function convertTimestamp(timestamp) {
  const momentObj = moment(timestamp);
  const formattedDate = momentObj.format('DD/MM/YYYY');
  const formattedTime = momentObj.format('hh:mm:ss A');

  return `${formattedDate} ${formattedTime}`;
}

function convertTransactionDates(json) {
  json.forEach(obj => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && moment(obj[key], moment.ISO_8601).isValid()) {
        const momentObj = moment(obj[key]);
        const formattedDate = momentObj.format('DD/MM/YYYY hh:mm:ss A');
        obj[key] = formattedDate;
      }
    }
  });
  return json;
}

function calculateColumnWidths(celldata) {
  const colWidths = {};

  celldata.forEach((cell) => {
    const { c, v } = cell;
    const content = v.v;
    const fontSize = cell.v.fs ? cell.v.fs : 12
    // const width = content.toString().length * 10 * fontSize/10; // 10 is an approximate width per character

    let width = content.toString().length * fontSize / 1.6
    // console.log('width',width)
    if (width){
      if (width <= 73) {
      width = 73
    }
    }

        
    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width;
    }
  });

  return colWidths;

}

function calculateColumnHeights(celldata) {
  const colHeights = {};

  celldata.forEach((cell) => {

    const { c, r } = cell;
    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize = cell.v.fs ? cell.v.fs : 12
    const lineHeight = fontSize * 1.2; // Calculate the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight;

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height;
    }
  });

  return colHeights;
}

function jsonToCelldata(jsonData) {
  const headers = ['Locker No', 'Locker Size', 'Locker Status', 'Current User', 'Transaction Date', 'Action', 'User'];
  console.log('jsonData', jsonData)
  const celldata = [];

  jsonData.forEach((item, row) => {
    if (row < 5) {
      //please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;

      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info, fs: item.fs ? item.fs : 12 },
      };
      celldata.push(infoCell);
    } else {
      if (row === 5) {
        headers.forEach((header, c) => {
          celldata.push({
            r: row,
            c,
            v: { m: header, ct: { fa: 'General', t: 's' }, v: header, bg: item.bg ? item.bg : '#FFFFFFF' },
          });
        });
      } else {
        const rowData = [
          item.lockerNo,
          item.lockerSize,
          item.lockerStatus,
          item.currentUser ? item.currentUser : '',
          item.transactionDate,
          item.action ? item.action : '',
          item.user ? item.user : '',
        ];


        rowData.forEach((value, c) => {
          console.log('rowData.forEach((value', value)
          const stringValue = value === undefined ? '' : value.toString();


          const cell = {
            r: row,
            c,
            v: {
              m: stringValue,
              ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
              v: stringValue,
              bg: item.bg ? item.bg : '#FFFFFF'
            },
          };
          celldata.push(cell);
        });
      }
    }
  });
  console.log('celldata', celldata)
  return celldata;
}

function addBorderToManyCell(data ,   { minusRow = 1,   minumumR = 4   ,  style = "1",  color = '#000000'  }) {
 
 let smallestR = Infinity;
   let smallestC = Infinity;

   let largestR = -1;
   let largestC = -1;


   for (let item of data) {
       if (item.r > minumumR && item.r < smallestR) {
           smallestR = item.r;
          
       }
       
       if (item.r > largestR) {
           largestR = item.r;
         
       }
       
       if (item.c < smallestC) {
           smallestC = item.c;
     
       }

       if (item.c > largestC) {
           largestC = item.c;
      
       }
   }

  var borderInfo = [];
 
 borderInfo.push({
   "rangeType": "range",
   "borderType": "border-all",
   "style": style,
   "color":color,
   "range": [{
       "row": [smallestR, largestR - minusRow ],
       "column": [smallestC, largestC]
   }]
   });


return borderInfo

}



function initLuckysheet(data) {
  border_1.value = []
  console.log('Sheet loaded')

  const celldata = jsonToCelldata(data);
  const colWidths = calculateColumnWidths(celldata);
  const colHeights = calculateColumnHeights(celldata);
  console.log('colHeights', colHeights);

  border_1.value = [...border_1.value , ...addBorderToManyCell(celldata , { minumumR : startingRowNumber.value - 1 , minusRow: 0 })] 


  var options = {
    container: 'luckysheet',
    title: 'Locker',
    lang: 'zh',
    showsheetbar: false,

    data: [
      {
        name: 'Sheet1',
        status: 1,
        celldata: celldata,
        config: {

          authority: {// 当前工作表的权限配置
            sheet: 1, // sheet表下标。
            hintText: "You can not edit any cell", // 弹窗提示的文字
          },
          merge: merge.value  , //merged cells
          // merge: merge.value !== {} ? merge.value : {}, //merged cells
          rowlen: {}, //Table row height
          columnlen: colWidths,
          rowlen: colHeights, //Table row height
 
          rowhidden: {}, //hidden rows
          colhidden: {}, //hidden columns
          borderInfo: border_1.value , //borders
        },
      },
      // {
      //   name: 'Sheet2',
      //   status: 1,
      //   celldata: celldata,
      //   config: {

      // // authority:{// 当前工作表的权限配置
      // //   sheet: 1, // sheet表下标。
      // //   hintText: "You can not edit any cell", // 弹窗提示的文字
      // // },

      //       merge:{}, //merged cells
      //       rowlen:{}, //Table row height
      //       columnlen: colWidths,
      //       // columnlen: {
      //       //       //自定义宽度
      //       //       0: "auto",
      //       //       1: 300,
      //       //       2: 300,
      //       //       3: 300,
      //       //       4: 300,
      //       //     },
      //       rowhidden:{}, //hidden rows
      //       colhidden:{}, //hidden columns
      //       borderInfo:{}, //borders
      //   },
      // },
    ],
  };

  return options
}

function callAPI(data) {
  showExcel(data)
    .then(lockerExcelresponse => {
      // console.log('lockerExcelresponse',lockerExcelresponse)
      let newArray = lockerExcelresponse.data.record;
      // console.log('newArray',newArray)
      // newArray = addBgToEverySecondRow(newArray)
      newArray = addBgToPreSecondLockerID(newArray)
      // console.log('addBgToPreSecondLockerID',newArray)
      newArray = convertTransactionDates(newArray)

      merge.value = generateMergeJson(newArray, 6 , 0)

      TempData.value = [...headerJSON.value, ...newArray];
      //  console.log('importData',importData.value)

      const temp = initLuckysheet(TempData.value)
      console.log('temp', temp)
      importData.value = temp



      // initLuckysheet(newValue)
    })

    .catch(err => {
      console.log('err', err)
    })
}



</script>